import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-transportforireland',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Transport for Ireland icon</title><path d="M0 0v12c0 6.62 5.38 12 12 12h12V11.978h-.022c0-6.62-5.38-11.978-12-11.978zm3.376 8.145h6.337v1.546h-2.33v6.12H5.706v-6.12h-2.33zm8.014 0h5.837V9.67h-4.138v1.633h3.659v1.546h-3.659v2.962H11.39zm7.535 0h1.678v7.666h-1.678Z"/></svg>`,
    styles: []
})
export class SimpleIconsTransportforirelandComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#113B92';
    @Input() className: string = 'simple-icons-transportforireland'
    constructor() {}
    ngOnInit(): void {}
}
